module.exports = __webpack_public_path__ + "img/DateRange.c32352a4.svg";